// import { useState } from "react"; // re-enable when profile photo upload ships

/**
 * Initials avatar. Profile photo is disabled. To bring it back: uncomment the
 * useState import above, the `loaded` state and `<img>` block below, and
 * restore the `loaded ? "bg-gray-100" : swatch` background in the className.
 */
const SWATCHES = ["bg-teal-600", "bg-primary-600", "bg-violet-600", "bg-amber-600", "bg-rose-600", "bg-cyan-700", "bg-primary-900"];

const SIZES = {
  sm: "h-8 w-8 text-[11px]",
  md: "h-9 w-9 text-xs",
  lg: "h-12 w-12 text-sm",
  xl: "h-20 w-20 text-xl",
};

const HONORIFICS = new Set(["dr", "dr.", "mr", "mr.", "mrs", "mrs.", "ms", "ms.", "prof", "prof.", "nurse"]);

export const nameToInitials = (fullName = "") => {
  const parts = fullName.split(" ").filter((w) => w && !HONORIFICS.has(w.toLowerCase()));
  if (!parts.length) return "";
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(0)}`.toUpperCase();
};

// eslint-disable-next-line no-unused-vars
const Avatar = ({ src, alt, size = "md", className = "", children }) => {
  // const [loaded, setLoaded] = useState(false);
  const name = typeof children === "string" ? children : "";
  const swatch = name ? SWATCHES[name.codePointAt(0) % SWATCHES.length] : SWATCHES[0];

  return (
    <div
      className={`relative flex flex-shrink-0 items-center justify-center overflow-hidden rounded-full font-semibold text-white ${swatch} ${SIZES[size]} ${className}`}
    >
      {nameToInitials(name)}
      {/* Photo upload isn't available yet — always show initials. Re-enable
          by restoring the `loaded` state above and this block, and swapping
          the className above back to `${loaded ? "bg-gray-100" : swatch}`.
      {src && (
        <img
          src={src}
          alt={alt || name}
          referrerPolicy="no-referrer"
          onLoad={() => setLoaded(true)}
          className={`absolute inset-0 h-full w-full object-cover ${loaded ? "" : "hidden"}`}
        />
      )} */}
    </div>
  );
};

export default Avatar;
